<div class="basket-overview-skeleton container-md" role="status" aria-live="polite" data-cy="BASKET_SKELETON">
    <!-- Title -->
    <div class="d-flex align-items-center gap-2 mb-4">
        <p-skeleton shape="circle" size="1.75rem"></p-skeleton>
        <p-skeleton height="1.75rem" width="12rem"></p-skeleton>
    </div>

    <!-- Stepper header -->
    <div class="basket-overview-skeleton__steps mb-4">
        @for (step of [0, 1, 2]; track step) {
            <div class="basket-overview-skeleton__step">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
                @if (!isMobile()) {
                    <p-skeleton height="0.9rem" width="7rem"></p-skeleton>
                }
            </div>
        }
    </div>

    <!-- Supplier cards -->
    @for (supplier of supplierPlaceholders; track supplier) {
        <div class="basket-overview-skeleton__card mb-3">
            <p-skeleton height="1.25rem" width="35%" styleClass="mb-3"></p-skeleton>

            @for (item of [0, 1]; track item) {
                <div class="basket-overview-skeleton__item">
                    <p-skeleton width="5rem" height="5rem" styleClass="basket-overview-skeleton__thumb"></p-skeleton>
                    <div class="basket-overview-skeleton__item-text">
                        <p-skeleton height="1rem" width="70%" styleClass="mb-2"></p-skeleton>
                        <p-skeleton height="0.85rem" width="40%" styleClass="mb-2"></p-skeleton>
                        <p-skeleton height="0.85rem" width="55%"></p-skeleton>
                    </div>
                    <div class="basket-overview-skeleton__item-side">
                        <p-skeleton height="1rem" width="4rem"></p-skeleton>
                    </div>
                </div>
            }

            <!-- Totals -->
            <div class="basket-overview-skeleton__totals">
                <p-skeleton height="0.85rem" width="9rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton height="0.85rem" width="7rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton height="1.1rem" width="11rem"></p-skeleton>
            </div>
        </div>
    }
</div>
